import ScheduleEdImportCoveredChecklistFieldsArray from '../../../Enums/ScheduleEdImportCoveredChecklistFieldsArray';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import OpportunitySecurityChecklistItem from '../../../Domain/OpportunitySecurityChecklistItem';
import EditOpportunitySecurityChecklistWindowDescription from './EditOpportunitySecurityChecklistWindowDescription';
import ImportContractReviewWindowDescription from './ImportContractReviewWindowDescription';

// The review of Import from Schedule D/E: the contract import's side-by-side review, with its own labels, the
// fields a Schedule D/E submission can fill, and the save flagged as this import for its audit comment.
export default class ImportScheduleEdReviewWindowDescription extends ImportContractReviewWindowDescription {
  static titleForCreate = 'Review Security Checklist from Schedule D/E';
  static titleForEdit = 'Review Security Checklist from Schedule D/E';
  static finishButtonLabel = 'Save reviewed checklist';

  // Restated though inherited: GeneralEditWizzardPageFigma SPREADS the description into its state, and a spread
  // copies own properties only.
  static itemType = OpportunitySecurityChecklistItem;
  static messageOnSuccess = 'The Security Checklist has been saved from the Schedule D/E answers.';

  static readOnlySideLabel = 'Current checklist';
  static editSideLabel = 'Schedule D/E answers';

  static serviceFunction = (edited) => OpportunitySecurityChecklistService.UpsertChecklist(edited, false, false, true);

  static pagesInGeneralEditWizzard = [
    ...ImportContractReviewWindowDescription.withNotFoundInfo(
      EditOpportunitySecurityChecklistWindowDescription.pagesInGeneralEditWizzard,
      ScheduleEdImportCoveredChecklistFieldsArray,
      'Not found in Schedule D/E'
    ),
    ImportContractReviewWindowDescription.confirmationPage(
      "I have double-checked these values against the client's Schedule D/E answers and confirm their accuracy.",
      "Values taken from the client's Schedule D/E answers. By saving, you confirm you have checked them and take responsibility for their accuracy.",
      'You must confirm the values match the Schedule D/E answers before saving.'
    ),
  ];
}
